export const emptyPageable: CMxAPI.PageableList<any> = {
  content: [],
  pageable: {
    sort: {
      sorted: false,
      unsorted: true,
      empty: true
    },
    offset: 0,
    pageSize: 25,
    pageNumber: 0,
    unpaged: false,
    paged: true
  },
  totalElements: 0,
  totalPages: 0,
  last: true,
  size: 0,
  number: 0,
  numberOfElements: 0,
  sort: {
    sorted: false,
    unsorted: true,
    empty: true
  },
  first: true,
  empty: true
};

export const defaultFilterableOptions: CMxCommonApp.FilterableOption = {
  dateFilter: undefined,
  filters: []
};

export const defaultSortablePageable: CMxCommonApp.SortablePageable<
  CMxAPI.DictionaryAction | CMxAPI.OrganizationAction
> = {
  pageableDefinition: { ...emptyPageable },
  sortableOptions: [
    {
      sortField: 'dateOfService',
      sortDirection: 'desc'
    },
    {
      sortField: 'id',
      sortDirection: 'desc'
    }
  ],
  filterableOptions: {
    ...defaultFilterableOptions
  }
};

/**
 * Build a new sortable pageable for list() callbacks without mutating frozen Redux props.
 * Resets pagination to the first page like the previous in-place mutations did.
 */
export function buildSortableWithFilters<T>(
  sortablePageable: CMxCommonApp.SortablePageable<T>,
  next: {
    filters: CMxCommonApp.Filter[];
    dateFilter: CMxCommonApp.DateFilter | undefined;
  }
): CMxCommonApp.SortablePageable<T> {
  const fo = sortablePageable.filterableOptions ?? {};
  const pd = sortablePageable.pageableDefinition;

  return {
    ...sortablePageable,
    filterableOptions: {
      ...fo,
      filters: next.filters,
      dateFilter: next.dateFilter
    },
    pageableDefinition: {
      ...pd,
      number: 0,
      first: true,
      last: false,
      pageable: {
        ...pd.pageable,
        pageNumber: 0,
        offset: 0
      }
    }
  };
}

export const searchParamsFactory = (
  params: CMxCommonApp.SortablePageable<any>
): URLSearchParams => {
  // there may be multiple sorts for a list
  // https://stackoverflow.com/a/33034533
  let sorts: string[][] = [];
  let pageables: string[][] = [];

  if (Array.isArray(params.sortableOptions)) {
    sorts = params.sortableOptions.map(opt => [
      `sort`,
      `${opt.sortField},${opt.sortDirection}`
    ]);
  }

  if (params.pageableDefinition) {
    pageables = [
      ['page', `${params.pageableDefinition.pageable.pageNumber}`],
      ['size', `${params.pageableDefinition.pageable.pageSize}`]
    ];
  }

  const searchParams = new URLSearchParams([...pageables, ...sorts]);
  return searchParams;
};

export const relatedCasesSortablePageable: CMxCommonApp.SortablePageable<
  CMxAPI.DictionaryAction | CMxAPI.OrganizationAction
> = {
  ...defaultSortablePageable,
  sortableOptions: [
    {
      sortField: 'dateOfService',
      sortDirection: 'desc'
    },
    {
      sortField: 'caseId',
      sortDirection: 'desc'
    }
  ]
};
